import { render, staticRenderFns } from "./AddLotModal.vue?vue&type=template&id=31abbbb5"
import script from "./AddLotModal.vue?vue&type=script&lang=js"
export * from "./AddLotModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports